import React from "react";
import { IconT } from "types/utils";

const HomeOutlineIcon = ({ height = "18", width = "18", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 12l8-7 8 7 M6 10v9h12v-9 M10 19v-5h4v5"
        stroke={fill}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default HomeOutlineIcon;
